<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:00em;">Susan Hulley who gave me the book that provided the inspiration.</p><br/>
<p style="text-indent:00em;">Anne Hand my wife for her encouragement and willingness to interrupt our retirement plans and let me get on with the walk and turn it into this publication.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?37a2d050